module.exports = __webpack_public_path__ + "static/media/ad.cb76422a.svg";